import React from 'react';
import { MedicalCrossIcon } from './medical-cross-icon';
import { TopicCardDivider, TopicCardTitle, TOPIC_CARD_ICON_1 } from './topic-card-shared';

import medicalPersonImage from './health-person.webp';

interface MedicalTopicCardProps {
  title: string;
  className?: string;
}

export const MedicalTopicCard: React.FC<MedicalTopicCardProps> = ({ title, className = '' }) => (
  <div
    className={`flex w-full min-w-0 flex-col items-center justify-center overflow-hidden rounded-xl bg-white px-2 pb-4 pt-3 sm:px-4 sm:pb-8 sm:pt-6 ${className}`}
  >
    <div className="mt-1 flex w-full flex-col items-center sm:mt-2">
      <div className="relative flex items-start justify-center">
        <div className="absolute left-0 top-4 h-[59px] w-[59px] shrink-0 sm:left-2 sm:h-[89.094px] sm:w-[89.094px]">
          <MedicalCrossIcon fill={TOPIC_CARD_ICON_1} className="h-full w-full" />
        </div>
        <img
          src={medicalPersonImage}
          alt=""
          className="relative z-10 ml-12 aspect-[47/68] w-[68px] shrink-0 object-cover object-top sm:ml-20 sm:w-[102.286px]"
        />
      </div>
      <TopicCardDivider />
    </div>
    <TopicCardTitle title={title} />
  </div>
);
